import { render, staticRenderFns } from "./ProjectTemplate.vue?vue&type=template&id=b81aee00&"
import script from "./ProjectTemplate.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTemplate.vue?vue&type=style&index=0&id=b81aee00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports